import unescapedText from 'I18n/utils/unescapedText';
import { APP_SORT_FIELD_ORDER_TUPLES, DEFAULT_APP_SORT_FIELD, DEFAULT_APP_SORT_ORDER } from '../constants/sortConstants';
export function isAppSortField(value) {
  return ['RELEVANCE', 'HUB_INSTALLS', 'FIRST_PUBLISHED', 'NAME'].includes(value);
}
export function isAppSortOrder(value) {
  return ['ASC', 'DESC'].includes(value);
}
export const getAppSortOptionText = (field, order) => {
  switch (field) {
    case 'RELEVANCE':
      return unescapedText('marketplace-ui-apps-core.results.sort.options.relevance');
    case 'HUB_INSTALLS':
      return unescapedText('marketplace-ui-apps-core.results.sort.options.mostInstalled');
    case 'FIRST_PUBLISHED':
      return unescapedText('marketplace-ui-apps-core.results.sort.options.newest');
    case 'NAME':
      return order === 'ASC' ? unescapedText('marketplace-ui-apps-core.results.sort.options.name') : unescapedText('marketplace-ui-apps-core.results.sort.options.nameReverse');
    default:
      return null;
  }
};
export const getAppSortOptionValue = (field, order) => `${field}:${order}`;
export const parseAppSortOptionValue = value => {
  const [sortField, sortOrder] = value.split(':');
  return {
    sortField: isAppSortField(sortField) ? sortField : DEFAULT_APP_SORT_FIELD,
    sortOrder: isAppSortOrder(sortOrder) ? sortOrder : DEFAULT_APP_SORT_ORDER
  };
};
export const getAppSortOptions = () => APP_SORT_FIELD_ORDER_TUPLES.map(([field, order]) => ({
  value: getAppSortOptionValue(field, order),
  text: getAppSortOptionText(field, order),
  disabled: false,
  tooltip: null
}));